var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClickDraw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00033 9.75C8.20845 9.75 9.18783 8.74264 9.18783 7.5C9.18783 6.25736 8.20845 5.25 7.00033 5.25C5.7922 5.25 4.81283 6.25736 4.81283 7.5C4.81283 8.74264 5.7922 9.75 7.00033 9.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70988 14.1358C5.49061 14.972 5.88098 15.3902 6.35623 15.5518C6.76338 15.6903 7.23727 15.6903 7.64442 15.5518C8.11968 15.3902 8.51004 14.972 9.29078 14.1358C11.2717 12.014 12.8337 9.92498 12.8337 7.5C12.8337 4.18629 10.222 1.5 7.00033 1.5C3.77866 1.5 1.16699 4.18629 1.16699 7.5C1.16699 9.92498 2.72898 12.014 4.70988 14.1358Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickDraw);
export default __webpack_public_path__ + "static/media/click_draw.00851c66cf952fc3b02ed5ce40dad686.svg";
export { ForwardRef as ReactComponent };